import type { HeadlineContent } from "@/types/report";

interface Props {
  content: HeadlineContent;
}

export function HeadlineSection({ content }: Props) {
  return (
    <div className="report-headline">
      {content.tagline && <div className="tagline">{content.tagline}</div>}
      <h1>{content.title}</h1>
    </div>
  );
}
